import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import {
	ApButtonMain,
	ApButtonDanger,
	ApChip,
	ApModal,
	ApSimpleSearch,
	colors,
	ApButtonIcon,
} from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	max-width: 700px;
`;

export const StyledModal = styled(ApModal)`
	.ap-modal-lightbox {
		background-color: rgba(50, 50, 50, 0.3);
	}
	.ap-modal-content {
		width: 800px;
		max-width: 800px;
		max-height: calc(100vh - 64px);
		border-radius: 1px;
		box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
	}

	.ap-modal-header {
		border-bottom: none;
		padding: 24px 32px 8px 32px;
		h4 {
			font-size: 23px;
			line-height: 31px;
			letter-spacing: 0.3px;
			color: ${colors.grey8};
			font-weight: 500;
		}
		.ap-button-icon {
			position: relative;
			top: -5px;
			right: -14px;
		}
	}

	.ap-modal-footer {
		display: none;
	}

	.ap-modal-body {
		padding: 16px 32px 16px 32px;
		line-height: 24px;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const FiltersContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
`;

export const FiltersLabel = styled.div`
	font-size: 23px;
	font-weight: 500;
	color: ${colors.grey8};
	white-space: nowrap;
	margin-right: 16px;
`;

export const ChipsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;

	> div {
		margin-bottom: 4px;
	}
`;

export const Selection = styled.div`
	display: flex;
	button:hover {
		background-color: ${rgba(colors.green2, 0.1)};
	}

	button:focus {
		background-color: ${rgba(colors.green2, 0.2)};
	}

	button:active {
		background-color: ${rgba(colors.green2, 0.3)};
		border: 1px solid ${colors.green3};
	}
`;

export const SearchWrapper = styled.div`
	display: flex;
	align-items: center;

	> div {
		width: 100%;
		height: 40px;
		margin: 0 8px;
	}

	.ap-simple-search {
		height: 40px;
	}
`;

export const DialogSearchWrapper = styled(SearchWrapper)`
	flex: 1;

	> div {
		margin-left: 24px;
	}
`;

export const StyledSearch = styled(ApSimpleSearch)`
	border-radius: 0;
	border-color: ${colors.grey4};
	height: 40px;

	&:focus:enabled,
	& ~ button:focus:enabled {
		box-shadow: none;
	}

	&:focus,
	&:hover {
		border-color: ${colors.green2};
	}

	&:active {
		border-color: ${colors.green3};
	}

	&:disabled {
		pointer-events: none;
		color: ${colors.grey5};
		border-color: ${colors.grey2};
	}
`;

export const QuickSearchContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 64px;
	background: ${colors.grey1};
	margin-left: -32px;
	margin-right: -32px;
	margin-top: 24px;
`;

export const QuickSearchLabel = styled.div`
	color: ${colors.grey6};
	font-size: 13px;
	margin-left: 32px;
`;

export const QuickSearchOptions = styled.div`
	display: flex;
	justify-content: flex-end;
	flex: 1;
`;

export const TableRows = styled.div`
	margin-left: -32px;
	margin-right: -32px;
	width: calc(100% + 64px);
	min-height: calc(100vh - 390px);
	max-height: calc(100vh - 390px);
	overflow: auto;
`;

export const TableNameCell = styled.div`
	height: 44px;
	display: inline-block;
	padding: 12px 8px;
	text-align: left;
	width: ${({ width }) => width}px;
	max-width: ${({ width }) => width}px;
`;

export const EllipsisSpan = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const TableCell = styled.div`
	height: 44px;
	display: flex;
	padding: 6px 8px;
	white-space: nowrap;
	align-items: center;
	justify-content: ${({ align }) =>
		align === 'left' ? 'flex-start' : 'flex-end'};
	flex: 1;
	width: ${({ width }) => width}px;
	${({ noMaxWidth, width }) =>
		!noMaxWidth &&
		css`
			max-width: ${width}px;
		`} overflow: hidden;
	text-overflow: ellipsis;
`;

export const NavigateLink = styled(ApButtonIcon)`
	margin-bottom: -8px;
	opacity: 0;
	transition: 0.2s opacity;
	:hover {
		svg {
			fill: ${colors.green1};
		}
	}
`;

export const TableRow = styled.div`
	width: 100%;
	min-width: 0;
	display: flex;
	font-size: 13px;
	:hover {
		background: ${colors.grey1};
		${NavigateLink} {
			opacity: 1;
			cursor: pointer;
		}
	}
	${({ isSelected }) =>
		isSelected
			? css`
					background: ${colors.green0};
					&:hover {
						background: ${colors.green0};
					}
			  `
			: ''};
`;

export const TableHeader = styled.div`
	margin-left: -32px;
	margin-right: -32px;
	display: flex;
	align-items: center;
	width: calc(100% + 64px);
	border-bottom: 1px solid ${colors.grey8};
`;

export const TableHeaderCol = styled(TableCell)`
	font-size: 13px;
	font-weight: 400;
	color: ${colors.grey5};
	cursor: pointer;
`;

export const SelectDimension = styled.div`
	display: flex;
	align-items: center;
	position: relative;
`;

export const RestoreButton = styled(ApButtonMain)`
	margin-left: 24px;
`;

export const DeleteButton = styled(ApButtonDanger)`
	margin-right: 24px;
`;

export const Pagination = styled.div`
	display: flex;
	align-items: center;
	margin-top: 16px;
`;

export const PaginationText = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${colors.grey5};
	margin-right: 16px;
`;

export const ActionText = styled.div`
	display: flex;
	align-items: center;
	height: 36px;
	font-size: 13px;
	font-weight: 400;
	color: ${colors.grey5};
`;

export const StyledChip = styled(ApChip)`
	background-color: ${colors.white};
	margin-bottom: 8px;
	text-transform: initial !important;
`;

export const HighlightedText = styled.span`
	font-weight: 500;
	color: ${colors.grey8};
`;

export const TooltipRow = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
`;

export const TooltipContent = styled.div`
	padding: 2px !important;
	word-wrap: break-word;
`;
